import { openPopup } from "./popupHandler.js";

import "@/styles/partials/gallery.css";

const images = document.querySelectorAll(
  ".gallery__container img, [data-gallery] img",
);

let galleryPopupImage = null;
let galleryPopupImageBg = null;
let selectedImage = null;

function initGallery() {
  galleryPopupImage = document.querySelector("#gallery_image_full_size");
  galleryPopupImageBg = document.querySelector("#gallery_image_full_size_bg");

  document
    .querySelector(".gallery__popup__next-button")
    .addEventListener("click", nextImage);
  document
    .querySelector(".gallery__popup__previous-button")
    .addEventListener("click", previousImage);

  document.addEventListener("keydown", galleryKeydown);

  images.forEach((image) =>
    image.addEventListener("click", (event) => {
      setPopupImage(event.currentTarget);
      openPopup("gallery");
    }),
  );
}

if (images.length) {
  initGallery();
}

function galleryKeydown(event) {
  if (document.body.dataset.dialog === "gallery") {
    switch (event.code) {
      case "ArrowLeft":
        previousImage();
        break;
      case "ArrowRight":
        nextImage();
        break;
    }
  }
}

function nextImage() {
  let sibling =
    selectedImage.nextElementSibling ||
    selectedImage.parentNode.firstElementChild;

  while (!sibling.matches("img")) {
    sibling =
      sibling.nextElementSibling || selectedImage.parentNode.firstElementChild;
  }

  setPopupImage(sibling);
}

function previousImage() {
  let sibling =
    selectedImage.previousElementSibling ||
    selectedImage.parentNode.lastElementChild;

  while (!sibling.matches("img")) {
    sibling =
      sibling.previousElementSibling ||
      selectedImage.parentNode.lastElementChild;
  }

  setPopupImage(sibling);
}

function setPopupImage(image) {
  selectedImage = image;
  galleryPopupImage.src = selectedImage.dataset.full_size || selectedImage.src;
  galleryPopupImage.alt = selectedImage.alt;

  if (galleryPopupImageBg) {
    galleryPopupImageBg.src =
      selectedImage.dataset.full_size || selectedImage.src;
  }
}
